// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CustomerBombayShirts$Showside from "../customers/CustomerBombayShirts.bs.js";
function toString(cn) {
  return "maker-nav maker-nav--" + cn;
}
function StylableElement(Props) {
  var className = Props.className;
  var children = Props.children;
  var experimentalStylingEnabled = CustomerBombayShirts$Showside.useIsBombay(undefined);
  if (className !== undefined && experimentalStylingEnabled) {
    return React.createElement("span", {
      className: "maker-nav maker-nav--" + className
    }, children);
  } else {
    return children;
  }
}
StylableElement.displayName = "StylableElement";
var make = StylableElement;
export { toString, make };
/* react Not a pure module */